import React from 'react';
import { SunIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-[#F5EDE0] py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-127">
      <div className="max-w-3xl mx-auto text-center" data-id="element-128">
        <div className="inline-flex items-center justify-center p-4 bg-[#FDF8F0] rounded-full mb-6 shadow-sm" data-id="element-129">
          <SunIcon className="w-10 h-10 text-[#B8A068]" aria-hidden="true" data-id="element-130" />
        </div>

        <h2 className="font-playfair text-3xl md:text-4xl font-bold text-[#3D2E1F] mb-8" data-id="element-131">
          El Método de Engrase Articular
        </h2>

        <p className="text-[#3D2E1F] text-left md:text-center" data-id="element-132">
          Este sistema no es "ejercicio". Es una técnica de micro-movimientos de
          baja intensidad diseñados para realizarse bajo el calor de tus
          cobijas. Al usar el calor residual de tu cuerpo y movimientos
          específicos de "bombeo", activamos la producción de líquido sinovial
          (tu lubricante natural) antes de que el peso de tu cuerpo presione tus
          rodillas y tobillos.
        </p>
      </div>
    </section>;
}